/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { publicCefrChallengeSampleSchema } from './public-cefr-challenge-sample-schema';

export const publicCefrV1DataSchema = z.object({
  totalCount: z.number(),
  samples: z.array(publicCefrChallengeSampleSchema),
});
